export default "__VITE_ASSET__Bgc9VYO$__"